import { map, size } from "lodash";
import ProductCard from "./ProductCard";
import OwlCarousel from "react-owl-carousel";
import { useRef } from "react";

const ProductCarousel = ({ landing_products , handlefavoriteClick }) => {

    const productRef = useRef(null);

    const options = {
        loop: false,
        margin: 24,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 70000,
        autoplayHoverPause: true,
        // navText: ["<i class='sprite'></i>", "<i class='sprite'></i>"],
        //navText: ["<< ", ">>"],
        //navContainer: ".custom-nav-",
        video: false,
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 2 },
            1280: { items: 3 },
            1440: { items: 3 },
        },
    };

    const goToNext = () => {
        productRef.current.next();
    };

    const goToPrev = () => {
        productRef.current.prev();
    };


    return (<div className="row">
        <div className="col-xxl-12">
            <div className="bg-white section-box logistic-company-images-wrap our-product-slider-wrape">
                <div className="company-Services-labal d-flex align-items-center ">
                    <h2 className="head">
                        <span><i className="product"></i> Our Products <sub>{size(landing_products)} Products</sub></span>
                    </h2>
                    {
                        size(landing_products) > 3 && <div className="nav-ctrl">
                            <button type="button" className="btn prev" onClick={goToPrev}>
                                <i className="sprite"></i>
                            </button>
                            <button type="button" className="btn next" onClick={goToNext}>
                                <i className="sprite"></i>
                            </button>
                        </div>
                    }

                </div>

                <div className="mt-2 position-relative crousel-wrape">
                    {
                        size(landing_products) > 3 && <OwlCarousel className='owl-theme section' margin={20} autoplay {...options} ref={productRef} key={Date.now()}>
                            {
                                map(landing_products, (val, k) => {
                                    return (<div className="review item">
                                        <ProductCard data={val} key={`s_${k}`} showContact={false} showDesc={false} showPrice={true} handlefavoriteClick={handlefavoriteClick} favKey={`fav_product_${val.id + '_'+ Date.now()}`}/>
                                    </div>)
                                })
                            }
                        </OwlCarousel>
                    }

                    {
                        size(landing_products) <= 3 && <div className="owl-theme section"> {
                            map(landing_products, (val, k) => {
                                return (<div className="review item">
                                    <ProductCard data={val} key={`s_${k}`} showContact={false} showDesc={false} showPrice={true} handlefavoriteClick={handlefavoriteClick} favKey={`fav_product_${val.id + '_'+ Date.now()}`}/>
                                </div>)
                            })
                        }
                        </div>
                    }

                </div>
            </div>
        </div>
    </div>)
}

export default ProductCarousel;